import { render, staticRenderFns } from "./AdminVerticalNavMenu.vue?vue&type=template&id=570ce441&scoped=true"
import script from "./AdminVerticalNavMenu.vue?vue&type=script&lang=js"
export * from "./AdminVerticalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./AdminVerticalNavMenu.vue?vue&type=style&index=0&id=570ce441&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ce441",
  null
  
)

export default component.exports